// extracted by mini-css-extract-plugin
export var csatScore = "_l1-5";
export var header = "_l1-1";
export var panelWrapper = "_l1-2";
export var postPreview = "_l1-3";
export var rightContent = "_l1-0";
export var wrappingText = "_l1-4";